import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

import { EndpointService, Endpoint } from '@services/endpoints';
import { ITimezonesServiceData } from './timezones.models';

@Injectable({
	providedIn: 'root'
})
export class TimezonesService {
	public data: ITimezonesServiceData = {
		timezones: [],
		timezonesByArea: {},
		timezonesOriginal: []
	};

	constructor(private httpClient: HttpClient, private endpointService: EndpointService) {}

	private clearCache(): void {
		this.data.timezones = [];
		this.data.timezonesByArea = {};
		this.data.timezonesOriginal = [];
	}

	public getTimezones(force = false): Observable<ITimezonesServiceData> {
		return new Observable<ITimezonesServiceData>((observer) => {
			if (this.data.timezonesOriginal.length === 0 || force) {
				this.clearCache();

				const url = this.endpointService.url(Endpoint.usersTzs);

				this.httpClient.get(url).subscribe(
					(res: any) => {
						this.data.timezonesOriginal = res;
						this.transformTimezones();
						observer.next(this.data);
						observer.complete();
					},
					(err: any) => {
						observer.error(err);
						observer.complete();
					}
				);
			} else {
				observer.next(this.data);
				observer.complete();
			}
		});
	}

	private transformTimezones(): void {
		this.data.timezonesOriginal.forEach((timezone: any) => {
			if (timezone.id === 'AET') {
				timezone.id = 'Australia/Eastern Standard Time';
			}

			if (
				(timezone.id.indexOf('Etc') === 0 && timezone.id !== 'Etc/UTC') ||
				timezone.id.indexOf('/') === -1 ||
				timezone.id.indexOf('SystemV') === 0 ||
				timezone.id.indexOf('Riyadh8') !== -1 ||
				(timezone.id.split('/')[1] === timezone.id.split('/')[1].toUpperCase() && timezone.id !== 'Etc/UTC') ||
				timezone.id.split('/').length > 2
			) {
				return;
			} else {
				timezone.area = timezone.id.split('/')[0];
				timezone.name = timezone.id.split('/')[1].replace(/_/g, ' ');
				timezone.name = timezone.name.replace(/([a-z])([A-Z])/, '$1 $2');

				if (timezone.name === 'Eastern Standard Time') {
					timezone.id = 'AET';
				}

				if (Number(timezone.offset)) {
					timezone.name += ` (UTC ${timezone.offset < 0 ? '' : '+'}${timezone.offset / 3600000})`;
				} else if (timezone.name === 'UTC') {
					timezone.name += '';
				} else {
					timezone.name += ' (UTC)';
				}

				this.data.timezones.push(timezone);
			}
		});

		this.data.timezones.sort((a, b) => {
			if (a.area < b.area) return -1;
			if (a.area > b.area) return 1;

			if (a.offset < 0 && b.offset < 0) {
				if (a.offset > b.offset) return -1;
				if (a.offset < b.offset) return 1;
			} else {
				if (a.offset < b.offset) return -1;
				if (a.offset > b.offset) return 1;
			}

			if (a.name < b.name) return -1;
			if (a.name > b.name) return 1;

			return 0;
		});

		this.data.timezones.forEach((timezone: any) => {
			if (!this.data.timezonesByArea[timezone.area]) {
				this.data.timezonesByArea[timezone.area] = [];
			}

			this.data.timezonesByArea[timezone.area].push(timezone);
		});
	}
}
